import type * as api from '@gitbook/api-client';
import { translationLanguageDescriptors } from '@gitbook/app-translations';
import { Emoji } from '@gitbook/spine-react';

/**
 * A span that displays a language with an emoji.
 */
export function TranslationLanguageSpan(props: { language: api.TranslationLanguage }) {
    const { language } = props;

    return (
        <div className="flex items-center gap-1.5">
            <Emoji code={translationLanguageDescriptors[language].emoji} size={16} />
            <span className="whitespace-break-spaces text-nowrap text-secondary text-ui-base">
                {translationLanguageDescriptors[language].label}
            </span>
        </div>
    );
}
